export default "__VITE_ASSET__DqmgXmGq__"